var classes = {"colorSwatchGroupContainer":"L7olQ","colorSwatchGroupColor":"hHICY","colorSwatchGroupExtraColor":"PmKmM"};

export { classes as default };
